<template>
	<div class="">
		<login-after-head-center></login-after-head-center>
		<div id="member" class="container home-container flex">
			<side-nav></side-nav>
			<div id="order-us" class="award-page">
				<div class="home-allTitle award-title-cg fc-bet">
					<span>我的订单</span>
					<a href="" class="back">返回</a>
				</div>



        <el-steps v-if="order.refundStatus===0" :active="orderStatus.size" align-center process-status="process" finish-status="success">
          <el-step title="客户下单" :description="orderStatus.cacheKeyCreateOrder"></el-step>
          <el-step title="确认订单" :description="orderStatus.confirmOrder"></el-step>
          <!--<el-step title="待发货" :description="orderStatus.paySuccess"></el-step>-->
          <el-step title="待收货" :description="orderStatus.deliveryGoods"></el-step>
          <!--<el-step title="待评价" :description="orderStatus.userTakeDelivery"></el-step>-->
          <el-step title="已完成" :description="orderStatus.checkOrderOver"></el-step>
        </el-steps>
        <el-steps v-else :active="order.refundStatus+1" align-center process-status="process" finish-status="success">
          <el-step title="用户下单" :description="orderStatus.cacheKeyCreateOrder"></el-step>
          <el-step title="用户申请退款" :description="orderStatus.applyRefund"></el-step>
          <el-step title="退款申请通过" :description="orderStatus.refundOrderSuccess"></el-step>
        </el-steps>



				<el-card class="box-card " style="margin-top: 15px;" shadow="never">
          <div class="operate-container">
            <i class="el-icon-warning color-danger" style="margin-left: 20px"></i>
            <span class="color-danger">当前订单状态：<span v-html="order.statusName"></span></span>

          </div>


					<div style="margin-top: 20px;"><svg  aria-hidden="true" class="svg-icon"
							style="color: rgb(96, 98, 102);">
							<use  href="#icon-marker"></use>
						</svg> <span class="font-small">基本信息</span></div>




					<div class="table-layout">
						<div class="el-row">
							<div class="table-cell-title el-col el-col-4">订单编号</div>
							<div class="table-cell-title el-col el-col-4">经销商名称</div>
							<div class="table-cell-title el-col el-col-4">订单类型</div>
							<div class="table-cell-title el-col el-col-4">配送方式</div>
							<div class="table-cell-title el-col el-col-4">物流单号</div>
							<div class="table-cell-title el-col el-col-4">订单可得积分</div>
						</div>
						<div class="el-row">
              <el-col :span="4" class="table-cell">{{order.orderId}}</el-col>

              <el-col :span="4" class="table-cell">
                <el-popover
                    placement="top-start"
                    title="经销商名称"
                    width="300"
                    trigger="hover"
                    :content="distributor.name">
                  <span slot="reference">{{distributor.name | formatLongText}}</span>
                </el-popover>
              </el-col>

              <el-col :span="4" class="table-cell">{{order.pinkName }}</el-col>
              <el-col :span="4" class="table-cell">{{order.shippingType | formatShippingType}}</el-col>
              <el-col :span="4" class="table-cell">{{order.deliverySn | formatNull}}</el-col>
              <el-col :span="4" class="table-cell">{{order.gainIntegral}}</el-col>
						</div>
					</div>



					<div style="margin-top: 20px;"><svg  aria-hidden="true" class="svg-icon"
							style="color: rgb(96, 98, 102);">
							<use  href="#icon-marker"></use>
						</svg> <span class="font-small">收货人</span></div>


          <div class="table-layout">
            <el-row>
              <!--<el-col :span="4" class="table-cell-title">用户昵称</el-col>-->
              <el-col :span="6" class="table-cell-title">收货人</el-col>
              <el-col :span="6" class="table-cell-title">手机号码</el-col>
              <el-col :span="6" class="table-cell-title">收货地址</el-col>
              <el-col :span="6" class="table-cell-title">用户备注</el-col>
              <!--<el-col :span="4" class="table-cell-title">管理员备注</el-col>-->
            </el-row>
            <el-row>
              <!--<el-col :span="4" class="table-cell">{{ distributor.name}}</el-col>-->
              <el-col :span="6" class="table-cell">{{order.realName}}</el-col>
              <el-col :span="6" class="table-cell">{{order.userPhone}}</el-col>
              <el-col :span="6" class="table-cell">
                <el-popover
                    placement="top-start"
                    title="收货地址"
                    width="300"
                    trigger="hover"
                    :content="order.userAddress">
                  <span slot="reference">{{order.userAddress | formatLongText}}</span>
                </el-popover>
              </el-col>
              <el-col :span="6" class="table-cell">
                <el-popover
                    placement="top-start"
                    title="用户备注"
                    width="300"
                    trigger="hover"
                    :content="order.mark">
                  <span slot="reference">{{order.mark | formatLongText}}</span>
                </el-popover>
              </el-col>
              <!--<el-col :span="4" class="table-cell">-->
              <!--  <el-popover-->
              <!--      placement="top-start"-->
              <!--      title="管理员备注"-->
              <!--      width="200"-->
              <!--      trigger="hover"-->
              <!--      :content="order.remark">-->
              <!--    <span slot="reference">{{order.remark | formatLongText}}</span>-->
              <!--  </el-popover>-->
              <!--</el-col>-->
            </el-row>
          </div>

					<div style="margin-top: 20px;"><svg  aria-hidden="true"
							class="svg-icon" style="color: rgb(96, 98, 102);">
							<use  href="#icon-marker"></use>
						</svg> <span class="font-small">商品信息</span></div>



          <el-table
              :data="order.cartInfoList"
              size="small"
              style="width: 100%;margin-top: 20px" >
            <el-table-column label="商品图片" width="150" align="center">
              <template slot-scope="scope">
                <router-link :to="{path:'/details',query:{unique:scope.row.cartInfoMap.productAttrUnique}}">
                  <img v-if="scope.row.cartInfoMap.productInfo.attrInfo.image" :src="scope.row.cartInfoMap.productInfo.attrInfo.image" style="height: 80px">
                  <img v-else-if="scope.row.cartInfoMap.productInfo.image" :src="scope.row.cartInfoMap.productInfo.image" style="height: 80px">
                  <img v-else src="../assets/noll.png"  style="height: 80px"/>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column label="商品名称" width="300" align="center">
              <template slot-scope="scope">
                <router-link :to="{path:'/details',query:{unique:scope.row.cartInfoMap.productAttrUnique}}">
                  <span v-if="scope.row.cartInfoMap.productInfo.storeName">{{scope.row.cartInfoMap.productInfo.storeName}}</span>
                  <span v-else>{{scope.row.cartInfoMap.productInfo.attrInfo.skuName}}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column label="属性" width="240" align="center">
              <template slot-scope="scope">
                <router-link :to="{path:'/details',query:{unique:scope.row.cartInfoMap.productAttrUnique}}">
                  <span>{{scope.row.cartInfoMap.productInfo.attrInfo.skuName}}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column label="价格/货号" width="240" align="center">
              <template slot-scope="scope">
                <router-link :to="{path:'/details',query:{unique:scope.row.cartInfoMap.productAttrUnique}}">
                  <p>单价：￥{{ (scope.row.cartInfoMap.vipTruePrice).toFixed(2) }}</p>
                  <p>货号：{{scope.row.cartInfoMap.productAttrUnique}}</p>
                </router-link>
              </template>
            </el-table-column>

            <el-table-column label="折扣" width="120" align="center">
              <template slot-scope="scope">
                {{(scope.row.cartInfoMap.discountPrice*scope.row.cartInfoMap.cartNum).toFixed(2)}}
              </template>
            </el-table-column>
            <el-table-column label="数量" width="100" align="center">
              <template slot-scope="scope">
                {{scope.row.cartInfoMap.cartNum}}
              </template>
            </el-table-column>
            <el-table-column label="小计"  align="center">
              <template slot-scope="scope">
                {{scope.row.refundStatus==0?('￥'+(scope.row.cartInfoMap.truePrice*scope.row.cartInfoMap.cartNum).toFixed(2)):"已取消"}}
              </template>
            </el-table-column>
          </el-table>
          <div style="float: right;margin: 20px">
            合计：<span class="color-danger">￥{{order.totalPrice}}</span>
          </div>
          <div style="margin-top: 60px">
            <svg-icon icon-class="marker" style="color: #606266"></svg-icon>
            <span class="font-small">费用信息</span>
          </div>
          <div class="table-layout">
            <el-row>
              <el-col :span="6" class="table-cell-title">商品合计</el-col>
              <!--<el-col :span="6" class="table-cell-title">运费</el-col>-->
              <el-col :span="6" class="table-cell-title">优惠券</el-col>
              <!--<el-col :span="6" class="table-cell-title">积分抵扣</el-col>-->
              <el-col :span="6" class="table-cell-title">订单总金额</el-col>
              <el-col :span="6" class="table-cell-title">应付款金额</el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="table-cell">￥{{ order.totalPrice }}</el-col>
              <!--<el-col :span="6" class="table-cell">￥{{order.payPostage}}</el-col>-->
              <el-col :span="6" class="table-cell">-￥{{ order.couponPrice }}</el-col>
              <!--<el-col :span="6" class="table-cell">-￥{{order.deductionPrice}}</el-col>-->
              <el-col :span="6" class="table-cell">
                <span class="color-danger">￥{{ order.totalPrice }}</span>
              </el-col>
              <el-col :span="6" class="table-cell">
                <span class="color-danger">￥{{ order.payPrice }}</span>
              </el-col>
            </el-row>
            <el-row>
              <!--<el-col :span="6" class="table-cell-title">活动优惠</el-col>-->
              <!--<el-col :span="6" class="table-cell-title">折扣金额</el-col>-->
            </el-row>
            <!--<el-row>-->
            <!--  &lt;!&ndash;<el-col :span="6" class="table-cell">-￥0</el-col>&ndash;&gt;-->
            <!--  &lt;!&ndash;<el-col :span="6" class="table-cell">-￥0</el-col>&ndash;&gt;-->
            <!--</el-row>-->
          </div>





          <div style="float: right;margin: 20px">

            <el-button size="mini"  @click="cancelOrder(order.orderId)" v-if="order.refundStatus === 0 && order.paid === 1 && (order.status == 0||order.status == 4)">取消订单</el-button>
            <el-button size="mini"  @click="takeOrder(order.orderId)" v-if="order.status == 1">确认收货</el-button>
            <el-button size="mini" class="btn-" v-if="order.status==3&&order.evaluate!=1" @click.prevent="openOrderCommentDialog(order.id)">
              评价
            </el-button>
          </div>
				</el-card>


			</div>
		</div>
		<i-footer></i-footer>
		<fixed-right></fixed-right>
    <!-- 评价弹出框 -->


    <el-dialog
        title="评价"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="closeOrderCommentDialog">


      <div class="evaluate-box" :class="{on:fileList.length>4}">
        <div class="fc">
          <span>商品质量</span>
          <el-rate
              v-model="orderComment.productScore"
              show-text>
          </el-rate>
        </div>
        <div class="fc">
          <span>服务态度</span>
          <el-rate
              v-model="orderComment.serviceScore"
              show-text>
          </el-rate>
        </div>

        <div class="textarea">
          <el-input type="textarea" v-model="orderComment.comment" placeholder="商品满足你的期待么？说说你的想法,分享给想买的他们吧"></el-input>

        </div>

        <el-upload
            class="upload-wrap"
            list-type="picture-card"
            multiple
            :limit="5"
            action="https://zxapi.tengen.com.cn/api/pc-shop/upload"
            :on-remove="handleRemove"
            :on-success="handleUploadSuccess"
            :before-remove="beforeRemove"
            :file-list="fileList"
            multiple

        >

          <i class="el-icon-plus"></i>

        </el-upload>

        <p>
          最多上传5张图片
          ({{fileList.length}}/5)
        </p>

      </div>

      <span slot="footer" class="dialog-footer">
		    <el-button @click="closeOrderCommentDialog">取 消</el-button>
		    <el-button type="primary" @click="submitOrderComment">确 定</el-button>
		  </span>
    </el-dialog>

	</div>
</template>

<script>
import {getNowOrderStatus, getOrderDetail, getOrderList, orderComment, takeOrder, verifyOrder} from "@/api/order";

  export default {

		data() {
			return {
        orderStatus:null,
        order: {
        },
        distributor: {},
				tableData: [
					{
					img:"http://cdn.web63.cn/1.jpg",
					sku: 'ckasg-1.4-1',
					name: 'CHKS',
					price:"￥942.00",
					productId:'050211741',
					discount:'94.70',
					num:1,
					total:'￥761.2',
					address: '上海市普陀区金沙江路 1518 弄'
				}],
        fileList:[],
        orderComment:{
          oid: 0,
          comment: '',
          pics: '',
          productScore: 5,
          serviceScore: 5
        },
			}
		},
		components: {},

		mounted: function() {
      this.orderDetail();
		},
    filters: {
      formatNull(value) {
        if(value===undefined||value===null||value===''){
          return '暂无';
        }else{
          return value;
        }
      },
      formatLongText(value) {
        if(value===undefined||value===null||value===''){
          return '暂无';
        }else if(value.length>8){
          return value.substr(0, 8) + '...';
        }else{
          return value;
        }
      },
      formatSourceType(value) {
        if (value === 1) {
          return '小程序';
        } else {
          return '公众号/H5';
        }
      },
      formatShippingType(value){
        if (value === 1) {
          return '快递';
        } else {
          return '门店自提';
        }
      },
      formatAddress(order) {
        let str = order.receiverProvince;
        if (order.receiverCity != null) {
          str += "  " + order.receiverCity;
        }
        str += "  " + order.receiverRegion;
        str += "  " + order.receiverDetailAddress;
        return str;
      },
      formatStatus(value) {
        if (value === 1) {
          return '待发货';
        } else if (value === 2) {
          return '已发货';
        } else if (value === 3) {
          return '已完成';
        } else if (value === 4) {
          return '已关闭';
        } else if (value === 5) {
          return '无效订单';
        } else {
          return '待付款';
        }
      },
      formatPayStatus(value) {
        if (value === 0) {
          return '未支付';
        } else if(value===4){
          return '已退款';
        }else{
          return '已支付';
        }
      },
      formatDeliverStatus(value) {
        if (value === 0||value === 1) {
          return '未发货';
        } else {
          return '已发货';
        }
      },
      formatProductAttr(value){
        if(value==null){
          return '';
        }else{
          let attr = JSON.parse(value);
          let result='';
          for(let i=0;i<attr.length;i++){
            result+=attr[i].key;
            result+=":";
            result+=attr[i].value;
            result+=";";
          }
          return result;
        }
      }
    },
		methods: {
      cancelOrder(orderId) {
        this.$prompt('请输入申请理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          verifyOrder({uni:orderId,text:value}).finally(() => {
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.changeType(this.type)
          });
        })
      },
      takeOrder(orderId) {
        this.$confirm('是否确认收货?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          takeOrder({uni: orderId}).finally(() => {
            this.$message({
              type: 'success',
              message: '收货成功!'
            });
            this.changeType(this.type)

          })
        });
      },
      orderDetail(){
        let that = this;
        let id = that.$route.query.orderId || 0;
        getNowOrderStatus(id).then(res => {
          this.orderStatus = res.data;
        })
        getOrderDetail(id).then(res=>{
          console.log(res)

          this.order = res.data;
          this.distributor = this.order.distributor;
        })
      }, openOrderCommentDialog(oid){
        this.fileList=[]
        this.orderComment={
          oid: oid,
          comment: '',
          pics: '',
          productScore: 5,
          serviceScore: 5
        }
        this.dialogVisible = true
      },
      closeOrderCommentDialog(){
        this.fileList=[]
        this.orderComment={
          oid: 0,
          comment: '',
          pics: '',
          productScore: 5,
          serviceScore: 5
        }
        this.dialogVisible=false
      },
      // 图片上传
      handleUploadSuccess(response, file, fileList) {
        console.log("handleUploadSuccess.response",response)
        console.log("handleUploadSuccess.file",file);
        console.log("handleUploadSuccess.fileList",fileList);
        var imgStr = fileList.map(function(obj,index){
          return obj.response.link;
        }).join(",");
        this.orderComment.pics = imgStr;
      },
      handleRemove(file, fileList) {
        console.log("handleRemove.file",file);
        console.log("handleRemove.fileList",fileList);
        var imgStr = fileList.map(function(obj,index){
          return obj.response.link;
        }).join(",");
        this.orderComment.pics = imgStr;
      },
      beforeRemove(file, fileList) {
        console.log("beforeRemove.file",file);
        console.log("beforeRemove.fileList",fileList);
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      submitOrderComment(){
        console.log("submitOrderComment",this.orderComment);
        orderComment(this.orderComment).then(res=>{
          this.$message({
            type: 'success',
            message: '评价成功!'
          });
          this.closeOrderCommentDialog()
          this.changeType(this.type)
        })
      },
      //dataFormat,
      setOfflinePayStatus: function(status) {
        var that = this
        that.offlinePayStatus = status
        if (status === 1) {
          if (that.payType.indexOf('offline') < 0) {
            that.payType.push('offline')
          }
        }
      },
      // takeOrder(order) {
      //   takeOrderHandle(order.orderId).finally(() => {
      //     this.reload()
      //   })
      // },
      reload() {
        this.changeType(this.type)
      },
      changeType(type) {
        this.orderDetail();
      },
      getStatus(order) {
        if(order._status._type==-1){
          return "申请退款中"
        }else if(order._status._type==-2){
          return "已退款"
        }
        return STATUS[order._status._type]
      }

		}
	}
</script>
<style lang="less">
	#member .product-table{
		.el-table--small .el-table__cell {
		    padding: 8px 0;
		}
	}
</style>
<style scoped lang="less">

	.svg-icon {
		width: 1em;
		height: 1em;
		vertical-align: -.15em;
		fill: currentColor;
		overflow: hidden;
	}

	.operate-container {
		background: #f2f6fc;
		height: 80px;
		margin: -20px -20px 0;
		line-height: 80px;
	}

	.table-layout {
		margin-top: 20px;
		border-left: 1px solid #dcdfe6;
		border-top: 1px solid #dcdfe6;
	}

	.table-cell-title,
	.table-cell {
		border-right: 1px solid #dcdfe6;
		border-bottom: 1px solid #dcdfe6;
		padding: 10px;
		font-size: 14px;
		text-align: center;
	}

	.table-cell-title {
		background: #f2f6fc;
		color: #303133;
	}
	.home-allTitle {

		.back{
			font-size: 13px;
			font-weight: normal;
			padding:0 15px;
		}
	}
</style>
